// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    CustomFieldCollectionOutput,
    CustomFieldCollectionOutputFromJSON,
    CustomFieldCollectionOutputToJSON,
    ExecutionTestCaseStatus,
    ExecutionTestCaseStatusFromJSON,
    ExecutionTestCaseStatusToJSON,
    Milestone,
    MilestoneFromJSON,
    MilestoneToJSON,
    User,
    UserFromJSON,
    UserToJSON,
} from './';

/**
 * 
 * @export
 * @interface Execution
 */
export interface Execution {
    /**
     * 
     * @type {number}
     * @memberof Execution
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Execution
     */
    title: string;
    /**
     * Statuses explanation:  * `0` - blah blah 0  * `1` - blah blah 1 
     * @type {number}
     * @memberof Execution
     */
    status: ExecutionStatusEnum;
    /**
     * 
     * @type {User}
     * @memberof Execution
     */
    createdBy: User;
    /**
     * 
     * @type {Milestone}
     * @memberof Execution
     */
    milestone: Milestone;
    /**
     * 
     * @type {number}
     * @memberof Execution
     */
    startDate?: number;
    /**
     * 
     * @type {number}
     * @memberof Execution
     */
    dueDate?: number;
    /**
     * 
     * @type {number}
     * @memberof Execution
     */
    created: number;
    /**
     * 
     * @type {Array<User>}
     * @memberof Execution
     */
    usersResponsible: Array<User>;
    /**
     * 
     * @type {Array<ExecutionTestCaseStatus>}
     * @memberof Execution
     */
    testCaseStatus: Array<ExecutionTestCaseStatus>;
    /**
     * Total number of test cases in this execution
     * @type {number}
     * @memberof Execution
     */
    totalTestCases: number;
    /**
     * Array of custom fields in this execution
     * @type {Array<CustomFieldCollectionOutput>}
     * @memberof Execution
     */
    customFields: Array<CustomFieldCollectionOutput>;
}

export function ExecutionFromJSON(json: any): Execution {
    return {
        'id': json['id'],
        'title': json['title'],
        'status': json['status'],
        'createdBy': UserFromJSON(json['created_by']),
        'milestone': MilestoneFromJSON(json['milestone']),
        'startDate': !exists(json, 'start_date') ? undefined : json['start_date'],
        'dueDate': !exists(json, 'due_date') ? undefined : json['due_date'],
        'created': json['created'],
        'usersResponsible': (json['users_responsible'] as Array<any>).map(UserFromJSON),
        'testCaseStatus': (json['test_case_status'] as Array<any>).map(ExecutionTestCaseStatusFromJSON),
        'totalTestCases': json['total_test_cases'],
        'customFields': (json['custom_fields'] as Array<any>).map(CustomFieldCollectionOutputFromJSON),
    };
}

export function ExecutionToJSON(value?: Execution): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'title': value.title,
        'status': value.status,
        'created_by': UserToJSON(value.createdBy),
        'milestone': MilestoneToJSON(value.milestone),
        'start_date': value.startDate,
        'due_date': value.dueDate,
        'created': value.created,
        'users_responsible': (value.usersResponsible as Array<any>).map(UserToJSON),
        'test_case_status': (value.testCaseStatus as Array<any>).map(ExecutionTestCaseStatusToJSON),
        'total_test_cases': value.totalTestCases,
        'custom_fields': (value.customFields as Array<any>).map(CustomFieldCollectionOutputToJSON),
    };
}

/**
* @export
* @enum {string}
*/
export enum ExecutionStatusEnum {
    NUMBER_0 = 0,
    NUMBER_1 = 1,
    NUMBER_2 = 2
}


